module.exports = __webpack_public_path__ + "static/media/S (25).983881fd.jpg";